module.exports = __webpack_public_path__ + "static/fonts/abhaya-libre-v6-latin-regular.86adfbb.ttf";